import { LoadingButton, LoadingButtonProps } from '@mui/lab'
import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { Route, RouteParameters } from '../../../../../constants'
import { useDoubleBookingContext } from '../../../../../hooks'
import { hydratePathname } from '../../../../../util'
import { useFormActionMode } from '../../../useFormActionMode'

type Props = Omit<LoadingButtonProps, 'onClick'>

const ActionButton = (props: Props) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const formActionMode = useFormActionMode()
  const { previouslyConfirmedAppointment } = useDoubleBookingContext()

  const reschedulePathname = useMemo(
    () =>
      hydratePathname(Route.APPOINTMENT_RESCHEDULE, {
        [RouteParameters.COUNTRY]: previouslyConfirmedAppointment?.country,
        [RouteParameters.APPOINTMENT_ID]: previouslyConfirmedAppointment?.id,
      }),
    [previouslyConfirmedAppointment?.id]
  )

  const onRescheduleClick = useCallback(() => navigate(reschedulePathname, { replace: true }), [navigate, reschedulePathname])

  const fullRescheduleUrl = `${window.location.origin}${reschedulePathname}`

  if (formActionMode === 'schedule') {
    return (
      <LoadingButton {...props} type="submit" variant="contained">
        {t('common.label.schedule')}
      </LoadingButton>
    )
  }

  if (formActionMode === 'reschedule') {
    return (
      <LoadingButton
        {...props}
        data-redirect={fullRescheduleUrl} // For debugging purposes
        onClick={onRescheduleClick}
        type="button"
        variant="outlined"
      >
        {t('common.label.reschedule')}
      </LoadingButton>
    )
  }

  return <></>
}

export { ActionButton }
